export function BellZFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M4.414 18H9a3 3 0 106 0h4.586c1.782 0 2.674-2.154 1.414-3.414l-2.093-2.093-.003-.01a4.5 4.5 0 01-3.678-7.57l-.172-.21-.08-.098a3 3 0 00-5.948 0l-.08.097c-.18.218-.427.525-.7.88-.534.697-1.205 1.63-1.634 2.458-.473.913-.87 2.116-1.142 3.046a33.978 33.978 0 00-.377 1.407L3 14.586C1.74 15.846 2.632 18 4.414 18z"
      ></path>
      <path
        fill="currentColor"
        d="M18 2a1 1 0 100 2h1.865l-3.633 4.36A1 1 0 0017 10h5a1 1 0 100-2h-2.865l3.633-4.36A1 1 0 0022 2h-4z"
      ></path>
    </svg>
  );
}
